module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338628/point02-de1b06708088c9831bfac3cb0b7133ee.png";